export default {
  INIT: 'request_init',
  SUCCESS: 'request_success',
  FAIL: 'request_fail',
};
